import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"chat-with-luni",
	() => import("../ui/chat-with-luni-popup"),
)
registerLazyNotificationRenderer("vpn", () => import("../ui/vpn-popup"))
registerLazyNotificationRenderer(
	"email-backup",
	() => import("../ui/email-backup-popup"),
)
